import { render, staticRenderFns } from "./BriqDummyPage.vue?vue&type=template&id=aa92cbb4&scoped=true&lang=pug&"
import script from "./BriqDummyPage.vue?vue&type=script&lang=js&"
export * from "./BriqDummyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa92cbb4",
  null
  
)

export default component.exports